import type { TypeShop } from '@/app/types/editor/shop';
import store from '@/app/store/store';

/**
 * State
 */
export const state = {
  __shop: null as TypeShop,
};

/**
 * Hàm lấy version của shop theo ngày tạo
 * @returns version: 20200310 (năm: 2020, tháng: 03, ngày: 10)
 */
export const getShopVersionInStore = (): number => {
  const shop = store.getValue('__shop');
  const createdAt = (shop as TypeShop)?.createdAt;

  let date = new Date().toISOString().slice(0, 10);
  if (createdAt) {
    date = new Date(createdAt).toISOString().slice(0, 10);
  }
  date = date.replace(new RegExp(/-/, 'gm'), '');
  return parseInt(date);
};

/**
 * Hàm lấy shop domain của khách hàng
 * @returns dachai.myshopify.com
 */
export const getDomainShopInStore = (): string | undefined => {
  const shop = store.getValue('__shop');
  const domain = (shop as TypeShop)?.shopifyDomain;
  if (domain) {
    return domain;
  }
  return;
};

/**
 * Hàm cập nhật một fields trong state của store
 * @param newPlan plan mới của khách
 * @returns kết hoàn thành hoặc không
 */
export const setPlanStoreInStore = (newPlan: string): boolean => {
  const shop = store.getValue('__shop') as TypeShop;
  if (shop) {
    shop.plan = newPlan;
    store.setValue('__shop', shop);
    return true;
  }
  return false;
};
